<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { AvatarRoot } from "reka-ui"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <AvatarRoot
    data-slot="avatar"
    :class="cn('relative flex size-8 shrink-0 overflow-hidden rounded-full shadow-[0_0_0_2px_var(--paper-stock),0_2px_5px_1px_var(--paper-shade)]', props.class)"
  >
    <slot />
  </AvatarRoot>
</template>
